import { FirebaseError } from 'firebase/app';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';

import logoZona from '../../assets/images/icons/logo.svg';
import InputForm from '../../components/InputForm/InputForm';
import { handleSignIn, resetPassword } from '../../firebase/firebaseAuth';
import api from '../../services/api';
import { Container, ContainerForgotPassword, ContainerInputs, ErrorMessage, LoginWrapper, PhoneSection, PhoneMockup, FloatingBadge } from './styles';
import { Icon } from '@iconify/react';
import { colors } from '../../styles/tokens';
import Button from '../../components/Buttons/Button';
import appPreview from '../../assets/images/app-preview.png';

const SignIn = () => {
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isSending, setIsSending] = useState(false);

    const loginSchema = yup.object().shape({
        email: yup.string().email("Invalid email").required("Email is required"),
        password: yup.string().required("Password is required"),
    });

    const forgotPassword = yup.object().shape({
        email: yup.string().email("Invalid email").required("Email is required"),
    });

    const handleLogin = async (e) => {
        e.preventDefault();
        setErrors({});
        try {
            await loginSchema.validate({ email, password }, { abortEarly: false });
            const result = await handleSignIn(email, password);
            navigate(result?.requires2FA ? "/two-factor-auth" : "/");
        } catch (error) {
            console.log(error);
            if (error instanceof yup.ValidationError) {
                const validationErrors = {};
                error.inner.forEach((err) => {
                    if (err.path) {
                        validationErrors[err.path] = err.message;
                    }
                });
                setErrors(validationErrors);
            } else if (error instanceof FirebaseError) {
                if (error.code === "auth/invalid-credential") {
                    setErrors({
                        ...errors,
                        credentialInvalid: "Invalid email or password",
                    });
                } else {
                    setErrors({ ...errors, firebase: error.message });
                    console.error("Error Invalid Credential:", error);
                }
            } else {
                console.error("Unknown error:", error);
            }
        }
    };


    const handleForgotPassword = async () => {
        setErrors({});
        setIsSending(true); // disable the button

        try {
            if (!email) {
                setErrors({ email: "Required to reset password" });
                return;
            }

            await forgotPassword.validate({ email }, { abortEarly: false });

            const { data } = await api.get(`/users/email/${email}`);

            if (!data.in_use) {
                toast.success("Password recovery email sent successfully. Check your inbox.");
                return;
            }

            const response = await api.get("/users/forgot-password", {
                params: { email },
            });

            toast.success("Password recovery email sent successfully. Check your inbox.");
        } catch (error) {
            if (error instanceof yup.ValidationError) {
                setErrors({ email: error.message });
            } else {
                console.error("Error sending password recovery email:", error);
                toast.error("Error sending password recovery email. Please try again.");
            }
        } finally {
            setIsSending(false); // re-enable the button
        }
    };



    return (
        <>
            <Container>
                <LoginWrapper>
                <ContainerInputs>
                    <div className='mb-3 mb-md-5 text-center'>
                        <img src={logoZona} alt="Logo Zona" />
                    </div>


                    <div>
                        <InputForm
                            placeholder="Enter e-mail"
                            label="E-mail"
                            onChange={(event) => setEmail(event.target.value)}
                            id="email"
                            value={email}
                            error={errors.email}
                        />

                        <InputForm
                            type="password"
                            placeholder="Enter password"
                            label="Password"
                            onChange={(event) => setPassword(event.target.value)}
                            id="password"
                            value={password}
                            error={errors.password}
                        />



                        {/* <button
                            onClick={handleLogin}
                            backgroundColor="linear-gradient(271.14deg, #7229F5 1.5%, #0A3FD6 98.6%)"
                        >
                            Continue
                        </button> */}

                        <span className='d-block w-100 pt-3 pb-4'>
                            <Button
                                label='Continue'
                                onClick={handleLogin}
                                gradientButton
                                textColor="#FFFFFF"
                                className='w-100 zona-pill-btn'
                            />
                        </span>


                        <ContainerForgotPassword>
                            <ErrorMessage>
                                {errors.credentialInvalid && (
                                    <span>{errors.credentialInvalid}</span>
                                )}
                            </ErrorMessage>

                            <button onClick={handleForgotPassword} disabled={isSending}>
                                {isSending ? "Sending..." : "Forgot password?"}
                            </button>

                        </ContainerForgotPassword>
                    </div>

                </ContainerInputs>
                <PhoneSection>
                    <PhoneMockup>
                        <img src={appPreview} alt="ZONA App" />
                    </PhoneMockup>
                    <FloatingBadge top="40px" right="-50px" delay="0.3s">
                        <Icon icon="solar:calendar-outline" style={{ fontSize: 18, color: '#2ECC71' }} />
                    </FloatingBadge>
                    <FloatingBadge top="180px" right="-70px" delay="0.5s">
                        <Icon icon="solar:users-group-rounded-outline" style={{ fontSize: 18, color: colors.brand }} />
                    </FloatingBadge>
                    <FloatingBadge bottom="200px" right="-50px" delay="0.7s">
                        <Icon icon="ph:champagne" style={{ fontSize: 18, color: '#F1C40F' }} />
                    </FloatingBadge>
                    <FloatingBadge bottom="80px" left="-40px" delay="0.4s">
                        <Icon icon="solar:chart-outline" style={{ fontSize: 18, color: colors.gradientStart }} />
                    </FloatingBadge>
                    <FloatingBadge top="120px" left="-50px" delay="0.6s">
                        <Icon icon="solar:ticket-outline" style={{ fontSize: 18, color: '#E74C3C' }} />
                    </FloatingBadge>
                    <FloatingBadge bottom="300px" left="-30px" delay="0.8s">
                        <Icon icon="solar:map-point-outline" style={{ fontSize: 18, color: colors.primary }} />
                    </FloatingBadge>
                </PhoneSection>
                </LoginWrapper>
            </Container>
        </>
    )
}

export default SignIn;